module.exports = __webpack_public_path__ + "img/MoonSword 2.818391b8.png";